import { render, staticRenderFns } from "./SelectMaterialDialog.vue?vue&type=template&id=13c20abb&scoped=true&"
import script from "./SelectMaterialDialog.vue?vue&type=script&lang=js&"
export * from "./SelectMaterialDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectMaterialDialog.vue?vue&type=style&index=0&id=13c20abb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c20abb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c20abb')) {
      api.createRecord('13c20abb', component.options)
    } else {
      api.reload('13c20abb', component.options)
    }
    module.hot.accept("./SelectMaterialDialog.vue?vue&type=template&id=13c20abb&scoped=true&", function () {
      api.rerender('13c20abb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/components/SelectMaterialDialog.vue"
export default component.exports